import { CALL_API } from '../../../middleware/api';
import { apiEndpoints } from '../../../services/ApiEndpointsConstants';
import * as API from '../../../services/ApiEndpointsConstants';
import * as DomainPageConstants from './DomainPageConstants';

export const getWhoIsData = (domainId) => {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints()
        .entity(API.WHO_IS_DATA)
        .replace('{domain}', domainId),
      types: [
        DomainPageConstants.GET_THIRD_PARTY_DATA_REQUEST,
        DomainPageConstants.GET_THIRD_PARTY_DATA_SUCCESS,
        DomainPageConstants.GET_THIRD_PARTY_DATA_ERROR
      ]
    }
  };
};

export function getAllDomainsForProcessing() {
  return {
    [CALL_API]: {
      endpoint: `${apiEndpoints().entity(API.GET_ALL_DOMAINS)}?limit=${
        process.env.REACT_APP_AMOUNT_DOMAINS_PENDING_LIMIT
      }`,
      types: [
        DomainPageConstants.GET_ALL_DOMAINS_FOR_PROCESSING_REQUEST,
        DomainPageConstants.GET_ALL_DOMAINS_FOR_PROCESSING_SUCCESS,
        DomainPageConstants.GET_ALL_DOMAINS_FOR_PROCESSING_FAILED
      ]
    }
  };
}

export function checkReservedDomainsIds(ids) {
  return {
    [CALL_API]: {
      endpoint: `${apiEndpoints().entity(API.CHECK_KEEP_DOMAINS)}?ids=${ids}`,
      types: [
        DomainPageConstants.CHECK_RESERVED_DOMAINS_IDS_REQUEST,
        DomainPageConstants.CHECK_RESERVED_DOMAINS_IDS_SUCCESS,
        DomainPageConstants.CHECK_RESERVED_DOMAINS_IDS_FAILED
      ]
    }
  };
}

export function getDomainImagesCountData(domainId) {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints()
        .entity(API.GET_SAME_DOMAIN_COUNT_DATA)
        .replace('{domainId}', domainId),
      types: [
        DomainPageConstants.GET_DOMAIN_IMAGE_COUNT_DATA_REQUEST,
        DomainPageConstants.GET_DOMAIN_IMAGE_COUNT_DATA_SUCCESS,
        DomainPageConstants.GET_DOMAIN_IMAGE_COUNT_DATA_FAILED
      ]
    }
  };
}

export function saveDomainData(domainId, requestData) {
  return {
    [CALL_API]: {
      config: {
        data: requestData,
        method: 'put',
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint: apiEndpoints()
        .entity(API.SAVE_DOMAIN_DATA)
        .replace('{domainId}', domainId),
      types: [
        DomainPageConstants.SAVE_DOMAIN_DATA_REQUEST,
        DomainPageConstants.SAVE_DOMAIN_DATA_SUCCESS,
        DomainPageConstants.SAVE_DOMAIN_DATA_FAILED
      ]
    }
  };
}

export const changeDomainDataContainer = (data, deleteIndex = null) => {
  return {
    type: DomainPageConstants.CHANGE_DOMAINS_WORK_DATA,
    data: data,
    deleteIndex: deleteIndex
  };
};
